
import { useQuery } from "@tanstack/react-query";
import { getReportsAnalyticsPerformance } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function usePerformance(options = {}) {
  const {
    onSuccess,
    onError,
    enabled = true,
    period = "30d",
    include_hourly = true,
  } = options;

  const {
    data,
    error,
    isLoading,
    refetch: reload,
  } = useQuery({
    queryKey: ["reportsPerformance", period, include_hourly],
    queryFn: async () => {
      try {
        const response = await getReportsAnalyticsPerformance({
          period,
          include_hourly,
        });
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
  });

  const metrics = data?.data || null;
  const generatedAt = data?.meta?.generated_at
    ? new Date(data.meta.generated_at).toLocaleString("ar-EG")
    : null;

  return {
    metrics,
    generatedAt,
    error,
    isLoading,
    reload,
    period,
  };
}





































































